import { StateParams } from "@uirouter/angularjs";
import { IOnInit, ICompileService } from "angular";
import { RecordDataSource } from "../../../../records/grids";
import { ColDef } from "../../../../records/grids/columns/colDef";
import {
  ColumnDefinitionService,
  vsName as ColumnDefinitionServiceName,
} from "../../../../records/grids/columns/columnDefinitionService";
import {
  GridSettingsService,
  IGridSettings,
  vsName as GridSettingsServiceName,
} from "../../../../records/grids/settings/gridSettingsService";
import { IQuery } from "../../../../records/server/query";
import {
  GridConfiguration,
  RecordGridViewService,
  RecordGridViewServiceProvider,
  vsServiceName as RecordGridViewServiceName,
} from "../../../../records/views/recordGridView";
import {
  vsName as serverUtilityName,
  ServerUtility,
} from "../../../../../app/records/server/serverUtility";

import { vsObjectName as contractName } from "../../../configs/contract"

import "angular-formly";
import { get } from "lodash";

const gridId = Symbol("main.contract.bulklog.result");
export class BulkLogResultController implements IOnInit {
  static $inject = [
    "$stateParams",
    "slotTrakMachinesServer",
    serverUtilityName,
    GridSettingsServiceName,
    ColumnDefinitionServiceName,
    RecordGridViewServiceName,
    "$compile"    
  ];
  readonly gridDataSource: RecordDataSource;
  readonly gridSettings: IGridSettings;
  readonly columns: ColDef[];
  readonly defaultQuery: IQuery = {};
  initialMachineIds = {};
  contractMachines!: any;
  logId: string = "";

  constructor(
    public readonly $stateParams: StateParams,
    public readonly slotTrakMachinesServer: any,
    public readonly serverUtility: ServerUtility,
    gridSettingsService: GridSettingsService,
    columnDefinitionService: ColumnDefinitionService,
    private readonly recordGridViewService: RecordGridViewService,
    $compile: ICompileService
  ) {
    this.logId = this.$stateParams["logId"];
    
    this.gridDataSource = new RecordDataSource(
      serverUtility,
      "/api/contract/bulklog/"+this.logId
    );
    console.log(this.gridDataSource);
    this.gridSettings = gridSettingsService.getGridSettings(gridId);

    const contractGridConfiguration = recordGridViewService.getGridConfiguration(contractName)

    this.columns = [
      columnDefinitionService.getLinkColDef({
        colId: "info",
        headerName: " ",
        iconClass: "fa fa-info-circle text-primary",
        stateExpression:
          "main.contract.info.Machine({ contractId: data.ContractId})",
        requiresPermission: "contractView",
      }),
      
      columnDefinitionService.getNumberColDef({
        field: "ContractId",
        header: "Contract Id",
      }),
      columnDefinitionService.getNumberColDef({
        field: "Succeeded",
        header: "Succeeded",
        cellRenderer: (params) => {
          const Succeeded = get(params.data, "Succeeded");
          if (Succeeded == 1) {
            return `<span class="badge text-bg-success">True</span>`;
          }else{
            return `<span class="badge text-bg-danger">False</span>`;
          }
  
        },
      }),
      columnDefinitionService.getStringColDef({
        field: "ErrorMessage",
        header: "Error",
      }),
      columnDefinitionService.getDateColDef({
        field: "CreatedDate",
        header: "Created Date",
      }),
      ...contractGridConfiguration?.columns ?? []
      
    ];
  }

  $onInit(): void {}
}
